// src/components/home/InternationalExport.tsx
import React from 'react';
import { Container, Grid, Text, ThemeIcon, Stack, Paper, useMantineTheme } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { 
  IconWorld, 
  IconShip, 
  IconPackage, 
  IconCertificate,
  IconTruck,
  IconChecklist 
} from '@tabler/icons-react';
import { useAppSelector } from '../../store/hooks';
import { SectionTitle } from '../common/SectionTitle';

const workflowIcons: Record<string, any> = {
  sourcing: IconWorld,
  inspection: IconChecklist,
  packaging: IconPackage,
  documentation: IconCertificate,
  shipping: IconShip,
  delivery: IconTruck,
};

export const InternationalExport: React.FC = () => {
  const { content } = useAppSelector((state) => state.content);
  const { workflowSteps } = content.pages.international;
  const theme = useMantineTheme();
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);
  const isTablet = useMediaQuery(`(max-width: ${theme.breakpoints.md})`);

  // Responsive values
  const paperPadding = isMobile ? 'md' : 'xl';
  const iconSize = isMobile ? 50 : isTablet ? 55 : 60;
  const iconIconSize = isMobile ? 25 : isTablet ? 28 : 30;
  const titleSize = isMobile ? 'sm' : 'lg';
  const descSize = isMobile ? 'xs' : 'sm';
  const gap = isMobile ? 'sm' : 'md';

  return (
    <Container size="xl" px={{ base: 0, sm: 'lg', md: 'xl' }}>
      <SectionTitle
        title={content.pages.home.sections.international.title}
        subtitle={content.pages.home.sections.international.description}
      />

      <Grid gutter={{ base: 'md', sm: 'lg', md: 'xl' }}>
        {workflowSteps.map((step) => {
          const IconComponent = workflowIcons[step.icon] || IconWorld;
          
          return (
            <Grid.Col key={step.id} span={{ base: 6, sm: 6, md: 4 }}>
              <Paper p={paperPadding} radius="lg" withBorder h="100%">
                <Stack align="center" gap={gap}>
                  <ThemeIcon size={iconSize} radius="xl" color="exportGreen" variant="light">
                    <IconComponent size={iconIconSize} />
                  </ThemeIcon>
                  <Text fw={700} size={titleSize} ta="center">
                    {step.step}. {step.title}
                  </Text>
                  <Text ta="center" size={descSize} c="dimmed">
                    {step.description}
                  </Text>
                </Stack>
              </Paper>
            </Grid.Col>
          );
        })}
      </Grid>
    </Container>
  );
};